var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"admin-page"},[_c('b-breadcrumb',{attrs:{"items":_vm.items}}),_c('b-row',{staticClass:"mt-3"},[_c('dashboard-stats')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }